var _g, _g2, _g3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLoader(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    style: {
      margin: "auto",
      background: "none",
      display: "block"
    },
    width: "200px",
    height: "200px",
    viewBox: "0 0 100 100",
    preserveAspectRatio: "xMidYMid",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "rotate",
    values: "360 50 50;0 50 50",
    keyTimes: "0;1",
    dur: "1.24s",
    repeatCount: "indefinite",
    calcMode: "spline",
    keySplines: "0.5 0 0.5 1",
    begin: "-0.124s"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 39.891,
    stroke: "#ffaab4",
    strokeWidth: 14.4,
    fill: "none",
    strokeDasharray: "0 300"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "stroke-dasharray",
    values: "15 300;55.1413599195142 300;15 300",
    keyTimes: "0;0.5;1",
    dur: "1.24s",
    repeatCount: "indefinite",
    calcMode: "linear",
    keySplines: "0 0.4 0.6 1;0.4 0 1 0.6",
    begin: "-0.05704s"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 39.891,
    stroke: "#ebeeea",
    strokeWidth: 7.2,
    fill: "none",
    strokeDasharray: "0 300"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "stroke-dasharray",
    values: "15 300;55.1413599195142 300;15 300",
    keyTimes: "0;0.5;1",
    dur: "1.24s",
    repeatCount: "indefinite",
    calcMode: "linear",
    keySplines: "0 0.4 0.6 1;0.4 0 1 0.6",
    begin: "-0.05704s"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 32.771,
    stroke: "#353434",
    strokeWidth: 1,
    fill: "none",
    strokeDasharray: "0 300"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "stroke-dasharray",
    values: "15 300;45.299378454348094 300;15 300",
    keyTimes: "0;0.5;1",
    dur: "1.24s",
    repeatCount: "indefinite",
    calcMode: "linear",
    keySplines: "0 0.4 0.6 1;0.4 0 1 0.6",
    begin: "-0.05704s"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 47.171,
    stroke: "#353434",
    strokeWidth: 1,
    fill: "none",
    strokeDasharray: "0 300"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "stroke-dasharray",
    values: "15 300;66.03388996804073 300;15 300",
    keyTimes: "0;0.5;1",
    dur: "1.24s",
    repeatCount: "indefinite",
    calcMode: "linear",
    keySplines: "0 0.4 0.6 1;0.4 0 1 0.6",
    begin: "-0.05704s"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "rotate",
    values: "360 50 50;0 50 50",
    keyTimes: "0;1",
    dur: "1.24s",
    repeatCount: "indefinite",
    calcMode: "spline",
    keySplines: "0.5 0 0.5 1"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffaab4",
    stroke: "#353434",
    d: "M97.2,50c0,6.2-1.2,12.3-3.6,18l-13.3-5.5c1.6-4,2.5-8.2,2.5-12.5"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ebeeea",
    d: "M93.6,50c0,1.2,0,2.4-0.1,3.7L93,57.3c-0.4,2.1-2.3,3.3-4.2,2.8L88.6,60c-1.9-0.5-3-2.3-2.7-3.9l0.4-3 c0.1-1,0.1-2,0.1-3.1",
    transform: "translate(0,-0.2)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#353434",
    d: "M87.1,65.4c-0.1,0.3-0.2,0.9-0.4,1.2c-0.2,0.2-0.5,0.4-0.8,0.3c-0.1,0-0.3-0.1-0.4-0.2 c-0.1-0.2-0.1-0.4,0.1-0.6c0.2-0.2,0.4-0.3,0.6-0.2c0.1,0.1,0.2,0.2,0.3,0.3c0.2,0.3,0.3,0.8,0.1,1.2c-0.1,0.4-0.5,0.7-0.9,0.8"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffaab4",
    stroke: "#353434",
    d: "M85.4,62.7c-0.2,0.7-0.5,1.4-0.8,2.1c-0.3,0.7-0.6,1.4-0.9,2c-0.3,0.5-1,1.2-1.5,1.3c-1.1,0.2-0.7-0.8-1.3-1.1 h0c-0.6-0.3-1.2,0.4-1.6-0.6c-0.2-0.5-0.1-1.3,0.2-1.8c0.3-0.6,0.5-1.2,0.8-1.8c0.2-0.6,0.6-1.2,0.7-1.8"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffaab4",
    stroke: "#353434",
    d: "M94.4,65.9c-0.3,0.9-0.7,1.7-1,2.6c-0.4,0.9-0.7,1.7-1.1,2.6c-0.4,0.7-1.1,1.5-1.8,1.7 c-1.2,0.4-0.7-0.9-1.3-1.2v0c-0.6-0.3-1.4,0.7-1.7-0.5c-0.2-0.6,0.1-1.6,0.4-2.2c0.4-0.8,0.7-1.5,1-2.3c0.3-0.8,0.7-1.5,0.9-2.3"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "rotate",
    values: "360 50 50;0 50 50",
    keyTimes: "0;1",
    dur: "1.24s",
    repeatCount: "indefinite",
    calcMode: "spline",
    keySplines: "0.5 0 0.5 1",
    begin: "-0.124s"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ebeeea",
    stroke: "#353434",
    d: "M88.9,30.8c0-0.5-0.2-1-0.2-1.5c0-0.5,0.2-1.1,0.6-1.3c0.4-0.2,0.8-0.1,1.2,0c0.6,0.2,1.2,0.5,1.8,0.9 c0.1,0.1,0.2,0.2,0.3,0.3c0.1,0.2,0,0.3,0,0.5c-0.1,0.5-0.2,1-0.3,1.5c-0.1,0.5-0.1,1-0.1,1.5C91.1,31.9,90,31.4,88.9,30.8z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ebeeea",
    stroke: "#353434",
    d: "M82.8,33.8c-0.4-0.3-0.7-0.6-1-0.8c-0.4-0.2-0.9-0.3-1.3-0.1c-0.4,0.2-0.6,0.6-0.7,0.9 c-0.2,0.5-0.4,1.1-0.5,1.6c0,0.1,0,0.2,0,0.3c0.1,0.1,0.2,0.1,0.4,0.2c0.4,0.1,0.8,0.2,1.2,0.4c0.4,0.2,0.7,0.4,1,0.6 C82.2,35.9,82.5,34.9,82.8,33.8z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffaab4",
    stroke: "#353434",
    transform: "translate(0,0.3)",
    d: "M97.2,50c0-4.9-0.8-9.8-2.3-14.5c-0.4-1.1-1-2.1-1.8-3c-0.4-0.4-0.8-0.8-1.2-1.1c-0.4-0.3-0.9-0.5-1.4-0.7 c-1.1-0.4-2.3-0.5-3.4-0.3c-0.6,0.1-1.3,0.3-1.8,0.7c-0.6,0.3-1.1,0.7-1.6,1.1c-0.9,0.8-1.5,1.7-2,2.7c-0.2,0.4-0.3,0.8-0.4,1.2 c-0.1,0.4-0.2,0.8-0.3,1.3c-0.1,0.8,0,1.7,0.3,2.4c1,3.3,1.5,6.6,1.6,10"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ebeeea",
    transform: "translate(0,0.3)",
    d: "M86.4,50c0-0.6,0-1.3-0.1-1.9l-0.1-1.9c0-0.4,0-0.8,0.1-1.2c0.1-0.4,0.3-0.8,0.6-1.1c0.5-0.7,1.3-1.2,2.3-1.4 l0.3,0c0.9-0.2,1.9,0,2.6,0.6c0.4,0.3,0.7,0.6,0.9,1c0.3,0.4,0.4,0.9,0.4,1.4l0.2,2.2c0.1,0.7,0.1,1.5,0.1,2.3"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffaab4",
    stroke: "#353434",
    d: "M86.8,42.2l0.4,2.2l0.2,1.1l0.1,1.1c0,0.6-0.2,1.5-0.6,1.9c-0.8,0.8-1.1-0.3-1.7-0.2c-0.7,0-0.8,1-1.7,0.4 c-0.5-0.3-0.8-1.1-0.8-1.6l-0.1-1l-0.2-1l-0.3-1.9"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffaab4",
    stroke: "#353434",
    d: "M96.2,40.2l0.5,2.8l0.2,1.4l0.1,1.4c0.1,0.8-0.1,1.9-0.5,2.4c-0.8,1-1.1-0.4-1.7-0.3h0c-0.7,0-0.8,1.3-1.7,0.5 c-0.5-0.4-0.8-1.4-0.9-2.1l-0.1-1.3l-0.2-1.2l-0.4-2.5"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#dbc08e",
    stroke: "#353434",
    d: "M89.7,36.7c0.3,0.8-0.4,1.8-1.4,2.1c-1,0.3-2-0.1-2.2-0.9c-0.3-0.7,0.3-1.6,1.2-2 C88.4,35.5,89.4,35.9,89.7,36.7z"
  }), /*#__PURE__*/React.createElement("line", {
    stroke: "#353434",
    x1: 87.5,
    y1: 37.3,
    x2: 87.6,
    y2: 37.6
  }), /*#__PURE__*/React.createElement("line", {
    stroke: "#353434",
    x1: 88.4,
    y1: 37,
    x2: 88.5,
    y2: 37.3
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#e6646e",
    d: "M92.4,33.9c0.1,0.3-0.3,0.8-0.9,1c-0.6,0.2-1.2,0.1-1.4-0.2c-0.1-0.3,0.3-0.8,0.9-1 C91.6,33.4,92.3,33.5,92.4,33.9z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#e6646e",
    d: "M82.3,37.7c0.1,0.3,0.7,0.3,1.3,0.1c0.6-0.2,1-0.6,0.9-0.9c-0.1-0.3-0.7-0.3-1.3-0.1 C82.6,37,82.2,37.4,82.3,37.7z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#353434",
    d: "M84.9,35.6c0.2,0.5-0.1,1-0.6,1.2c-0.5,0.2-1,0-1.2-0.5c-0.2-0.4,0.1-1,0.6-1.2C84.2,35,84.7,35.2,84.9,35.6z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#353434",
    d: "M90.7,33.2c0.2,0.5,0,1.1-0.5,1.3c-0.5,0.2-1.1-0.1-1.3-0.6c-0.2-0.5,0-1.1,0.5-1.3C89.9,32.4,90.5,32.7,90.7,33.2z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoader);
export default __webpack_public_path__ + "static/media/Loader.643fc60f02a7813ac4069dd649e29b1e.svg";
export { ForwardRef as ReactComponent };